import { render, staticRenderFns } from "./RegistrarPuesto.vue?vue&type=template&id=9f229adc&scoped=true&"
import script from "./RegistrarPuesto.vue?vue&type=script&lang=js&"
export * from "./RegistrarPuesto.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarPuesto.vue?vue&type=style&index=0&id=9f229adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f229adc",
  null
  
)

export default component.exports